<template>
  <!--<div class="logo" >-->
  <el-menu class="navbar" mode="horizontal">
    <!--图标-->
    <div class="left-menu">
      <hamburger :isActive="sidebar.opened" :toggleClick="toggleSideBar" class="left-menu-container"></hamburger>
      <router-link to="/index">
        <svg-icon class-name='left-menu-logo' icon-class="navl-logo"/>
      </router-link>
    </div>
    <div class="right-menu">
      <!--<error-log class="errLog-container right-menu-item"></error-log>-->
      <user-console v-show="dashboardShow > 1 ? false: true"></user-console>
      <!--<el-tooltip effect="dark" :content="$t('navbar.screenfull')" placement="bottom">-->
      <!--<screenfull class="screenfull right-menu-item"></screenfull>-->
      <!--</el-tooltip>-->

      <!--<lang-select class="international right-menu-item" :langType="langType"></lang-select>-->

      <!--<el-tooltip effect="dark" :content="$t('navbar.theme')" placement="bottom">-->
      <!--<theme-picker class="theme-switch right-menu-item"  ></theme-picker>-->
      <!--</el-tooltip>-->

      <div class="avatar-container right-menu-item">
        <div class="avatar-wrapper">
          <div>
            <el-popover
              placement="bottom"
              popper-class="popperClass2"
              trigger="hover"
              width="160"
            >
              <!--<router-link to="/">-->
              <el-dropdown-item>
                <div class="my-name" style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                  <div class="my-name-data">
                    {{ userName }}
                  </div>
                  <div class="my-name-orger">
                    {{ endOrgName }}
                  </div>
                </div>
              </el-dropdown-item>

              <el-dropdown-item>
                <el-popover
                  placement="left"
                  popper-class="popperClass"
                  trigger="hover"
                  width="150">
                  <el-dropdown-item :disabled="language==='en'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('en')">
                      English
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='zh'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('zh')">
                      中文(简体)
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='zh_ft'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('zh_ft')">
                      中文(繁體)
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='fr'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('fr')">
                      Français
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='es'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('es')">
                      Español
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='pt'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('pt')">
                      Português
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='de'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('de')">
                      Deutsch
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='it'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('it')">
                      Italiano
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='ru'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('ru')">
                      Русский
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='mn'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('mn')">
                      Монгол хэл
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='ar'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('ar')">
                      العربية
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='th'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('th')">
                      ภาษาไทย
                    </div>
                  </el-dropdown-item>

                  <el-dropdown-item :disabled="language==='vi'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('vi')">
                      Tiếng Việt
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='id'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('id')">
                      Indonesia
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='hu'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('hu')">
                      Magyar
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='fa'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('fa')">
                      فارسی
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='he'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('he')">
                      עִבְרִית
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='ko'">
                    <div style="text-align: center" @click="handleSetLanguage('ko')">
                      <!--Chinese-->
                      한국어
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="language==='ja'">
                    <div style="text-align: center;width: 100%;height: 100%" @click="handleSetLanguage('ja')">
                      日本語
                    </div>
                  </el-dropdown-item>


                  <div slot="reference" style="text-align: center">
                    <i :class="language === 'zh' ? 'el-icon-control-lang':'el-icon-control-lang1'"
                       class="file-btn-icon el-icon-control-iconLeft"></i>
                    {{ $t('navbar.language') }}
                  </div>
                </el-popover>
              </el-dropdown-item>
              <!--</router-link>-->
              <el-dropdown-item v-if="isPublicCloud == false ? false : userStatus == 1 ? false:true">
                <div style="text-align: center" @click="$emit('handleFeedback')">
                  {{ $t('feedback.Feedback') }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="userStatus == 1 ? false:true">
                <div style="text-align: center" @click="logout">
                  {{ $t('navbar.logOut') }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="userStatus == 1 ? true:false">
                <div class="logout" @click="BackClick">
                  {{ $t('navbar.BackTianwa') }}
                </div>
              </el-dropdown-item>
              <div slot="reference">
                <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">
                <i class="el-icon-caret-bottom"></i>
              </div>
            </el-popover>
          </div>

        </div>

      </div>
    </div>
  </el-menu>

  <!--</div>-->
</template>

<script>
import {mapGetters} from 'vuex'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import LangSelect from '@/components/LangSelect'
import ThemePicker from '@/components/ThemePicker'
import UserConsole from './UserConsole'
import {getPublicCloud} from "../../../api/equipmentMge";

export default {
  data() {
    let _this = this
    return {
      userName: '',
      endOrgName: '',
      isPublicCloud: true,
      dialogFormVisible: false,
      dashboardShow: _this.$store.state.user.roletype,
      userStatus: _this.$store.state.user.userStatus
      // langType: false
    }
  },
  components: {
    Hamburger,
    ErrorLog,
    Screenfull,
    LangSelect,
    ThemePicker,
    UserConsole
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'avatar'
    ]),
    language() {
      return this.$store.getters.language
    }
  },
  created() {
    this.getPublicCloud()
    this.selectUserBindRoleByUserId()
    if (this.$store.getters.userName == undefined || this.$store.getters.userName == "") {
      this.userName = ""
    } else {
      this.userName = this.$store.getters.userName
    }
    if (this.$store.getters.endOrgName == undefined || this.$store.getters.endOrgName == "") {
      this.endOrgName = ""
    } else {
      this.endOrgName = this.$store.getters.endOrgName
    }
  },
  methods: {
    //3.1.12 获取工程私有云设置
    async getPublicCloud() {
      // 判断是否公有云，私有云就显示上传按钮
      try {
        let data = await getPublicCloud()
        this.isPublicCloud = data.jsonBody.msgBody.isPublicCloud == 'false' ? false : true
      } catch (e) {
        // console.log('e',e);
      } finally {

      }
    },
    BackClick() {
      if (this.$store.state.user.thirdUrl == undefined) {
        window.location.href = 'https://www.tianwayun.com/'
      } else {
        window.location.href = this.$store.state.user.thirdUrl
      }

    },

    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang)
      if (lang == "zh") {
        document.title = 'Q-NEX管理后台'
      } else if (lang == "en") {
        document.title = 'Q-NEX Dashboard'
      } else if (lang == "ko") {
        document.title = 'Q-NEX Dashboard'
      } else {
        document.title = 'Q-NEX Dashboard'
      }
      this.$message({
        message: 'switch language success',
        type: 'success'
      })
      this.$router.go(0)
    },
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')

    },

    selectUserBindRoleByUserId() {

    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        // location.reload()// In order to re-instantiate the vue-router object to avoid bugs
        window.location.href = "/console/login"
      })
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.navbar {
  height: 70px;
  line-height: 70px;
  border-radius: 0px !important;
  background-color: #2D3A4B;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .left-menu {
    float: left;
    height: 100%;

    .left-menu-container {
      fill: #ffffff;
      float: left;
      margin: 0px 20px;

      .hamburger {
        width: 24px;
        height: 24px;
        vertical-align: middle;
      }
    }

    .left-menu-logo {
      width: 150px;
      height: 37px;
      margin-top: 15px;
      color: #fff;
    }
  }

  .right-menu {
    float: right;
    height: 100%;
    margin-right: 42px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }

    .screenfull {
      height: 20px;
    }

    .international {
      vertical-align: top;
    }

    .theme-switch {
      vertical-align: 15px;
    }

    .avatar-container {
      height: 50px;
      margin-right: 30px;

      .avatar-wrapper {
        cursor: pointer;
        margin-top: 14px;
        position: relative;
        height: 100%;

        .el-popover__reference {
          height: 100%;
          height: 50px;
        }

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}

.my-name {
  margin-top: 5px;
  border-bottom: 1px solid rgba(228, 231, 237, 1);

  .my-name-data {
    font-weight: 700;
    color: rgba(179, 179, 180, 1);
    height: 16px;
    line-height: 16px;
  }

  .my-name-orger {
    font-weight: 400;
    color: #B3B3B4;
    font-size: 12px;
    height: 30px;
    line-height: 28px;
    width: 146px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/LogoView.vue